export const eventBus = new EventTarget();

export class CloseMenuEvent extends CustomEvent<{ senderId: string; }> {

    public constructor( senderId: string ) {

        super( 'close-menu', { detail: { senderId } });

    }

}

let emitId = 0;

export function getEmitterId(): string {

    const result = emitId;
    emitId++;
    return result.toString();

}
